import data from '@emoji-mart/data';
import { init, SearchIndex } from 'emoji-mart';

void init({ data });

export { SearchIndex };

export interface EmojiData {
  id: string;
  name: string;
  native: string;
  shortcodes: string;
  skins?: Array<{ native: string }>;
}
